import { useQuery } from 'react-query';
import { POST, getRecaptchaToken } from './http-service';
import { useClientStateDataUpdate } from 'hooks/clientStateData';

const positonOptions = { maximumAge: 60000, timeout: 5000, enableHighAccuracy: true };

export const Location = ({journeyGuid, lngCode, rcaEnabled, executeRecaptcha, useMock}) => {

  const baseApi = `${lngCode}`;
  const clientStateDataUpdate = useClientStateDataUpdate();

  return {
    useUnitQuery(hasRecaptcha ,currentPosition, serviceTypeId, appointmentTypeId, customerGUID, journeyGUID, unitId, serviceId, calendarIds, selectedSlot, selectedDate, questionAnswerDict) {
      return useQuery(
        ['active-query', 'units', appointmentTypeId, serviceTypeId, serviceId],
        () => getUnits(journeyGuid, lngCode, hasRecaptcha, serviceTypeId, appointmentTypeId, currentPosition, customerGUID, journeyGUID, unitId, serviceId, calendarIds, selectedSlot, selectedDate, questionAnswerDict),
      );
    },
    useCurrentPositionQuery(journeyGUID) {
      return useQuery(['active-query', 'current-location', journeyGUID],
      () => getPosition(positonOptions)
      );
    },
  };

async function getUnits(journeyGuid, lngCode ,hasRecaptcha, serviceTypeId, appointmentTypeId, currentPosition, customerGUID, journeyGUID, unitId, serviceId, calendarIds, selectedSlot, selectedDate, questionAnswerDict) {

  const latitude = currentPosition?.coords?.latitude || currentPosition?.coords[0]
  const longitude = currentPosition?.coords?.longitude || currentPosition?.coords[1]
  if(useMock){
    return Promise.resolve(() =>
    {
      return [...Array(3).keys()].map(x=>{
        const id = ++x;
        return {
          unitId: id,
          unitName: `location ${id}`,
          unitLatitude: `3${id}.815864337196295`,
          unitLongitude: `-8${id}.79105060724864`,
          unitTypeId: 2,
          unitDescription: null,
          extRef: null,
          unitLevel: 1,
          address: null,
          telNumber: null,
          unitPublicName: `location ${id}`,
          unitPublicDescription: null,
          unitPublicAddress: null,
          unitPublicTelPhoneNumber: null,
          unitIdPath: `${id}`
        }
      })

    })
  }

  const clientStateData = {}

  if (serviceTypeId) clientStateData.serviceTypeId = serviceTypeId;
  if (appointmentTypeId) clientStateData.appointmentTypeId = appointmentTypeId;
  if (customerGUID) clientStateData.customerGUID = customerGUID;
  if (unitId) clientStateData.unitId = unitId;
  if (serviceId) clientStateData.serviceId = serviceId;
  if (calendarIds) clientStateData.calendarIds = calendarIds;
  if (selectedSlot) clientStateData.selectedSlot = selectedSlot;
  if (selectedDate) clientStateData.selectedDate = selectedDate;
  if (questionAnswerDict) clientStateData.questionAnswerDict = questionAnswerDict;

  const params = {};

  if (lngCode) params.lngCode = lngCode;
  if (journeyGuid) params.journeyGUID = journeyGUID;
  if (latitude) params.latitude = latitude.toString();
  if (longitude) params.longitude = longitude.toString();

  params.clientStateData = clientStateData ? clientStateData : null

  const headers = (!!rcaEnabled && hasRecaptcha && getRecaptchaToken( await executeRecaptcha('locations') )) || {} ;

  const response = await POST(`${baseApi}/units/findunits`, params, headers );

  if (response.clientStateData){ clientStateDataUpdate(response.clientStateData)}

  return response.units
}

async function getPosition() {
  return new Promise((resolve, reject) =>
    navigator.geolocation.getCurrentPosition(resolve, reject, positonOptions)
  )
  .then((res) => {
    return { coords: [res.coords.latitude, res.coords.longitude] };
  })
  .catch(async () => {
    // TODO: [RC] add error handling    
    return {};
  });
}

};